export const DetailsSpacer = () => {
  return (
    <div className="lg:w-2.5 lg:ml-24 md:w-2.5 md:ml-24 w-2 ml-20 bg-gray-200 lg:h-8 md:h-8 h-6" />
  );
};
